
type SomeFunction = (...args: any[]) => void;

type Timer = ReturnType<typeof setTimeout>;

export function useDebounce(func: SomeFunction, ms: number = 300) {
    let idTimer: Timer
    function executedFunction(...args: any[]) {
        const later = () => {
            clearTimeout(idTimer)
            func(...args)
        }
        clearTimeout(idTimer)
        idTimer = setTimeout(later, ms)
    }

    executedFunction.cancel = function () {
        clearTimeout(idTimer)
    }

    return executedFunction
}